import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';


export function signupAction(regData, navigate) {	
    return (dispatch) => {
        signUp(regData)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
           /* runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                //history,
            );*/
            dispatch(confirmedSignupAction(response.data));
            navigate('/dashboard');
			//history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate) {
	localStorage.removeItem('userDetails');
    navigate('/login');
	//history.push('/login');
    
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(loginData, navigate) {
    return  (dispatch) => {
         login(loginData)
            .then((response) => { 
               
                if(response && response.data && response.data.success)
                {
                 saveTokenInLocalStorage(response.data);
              
                  let authData = {
                    id: response.data.userdata.id,
                    name: response.data.userdata.first_name,
                    lastName: response.data.userdata.last_name,
                    email: response.data.userdata.email,
                    idToken: response.data.token,
                    localId: '',
                    expiresIn: '',
                    refreshToken: '',
                 }
                dispatch(loginConfirmedAction(authData));			              
				navigate('/dashboard');    
             }else
             {
               
                const errorMessage = response.data.message;              
                dispatch(loginFailedAction(errorMessage));
             }            
            })
            .catch((error) => {	
                let errorMessage = "Something wrong";		
                if(error?.response)
                {
                     errorMessage = formatError(error?.response?.message);
                }
               
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
